import axios from 'axios'

// 根据环境动态设置 baseURL
// 开发环境：使用相对路径，让 vue.config.js 的 proxy 配置生效
// 生产环境：使用 www.qdeso.com 并自动适配协议
const isDevelopment = process.env.NODE_ENV === 'development'

let baseURL
if (isDevelopment) {
  // 开发环境使用相对路径，配合 proxy
  baseURL = '/'
} else {
  // 生产环境自动适配协议
  const protocol = window.location.protocol
  baseURL = `${protocol}//www.qdeso.com/`
}

const http = axios.create({
  baseURL: baseURL,
  timeout: 10000,
})
// 添加请求拦截器
http.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  });

export default http